import React from 'react';
import axios from 'axios';
import * as turf from '@turf/turf';
import _, { isEqual } from 'lodash';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import { withStyles } from '@material-ui/core/styles';
import { minimapStyles, previewStyles } from '../../../Mapbox/Draw/draw-styles';
import Map from '../../PrintMapWithDraw';
import { SimplifyFilters } from '../../../../redux/layer_settings/Actions';

import { CircularProgress, Typography } from '@material-ui/core';
import PreviewMapImage from './PreviewMapImage';


export function PrintMapInner ({ baseLayer, layers, activeLayers, drawnFeatures, fitBounds, onStyleLoaded, ...otherProps }) {
    return (
        <Map
            baseLayer={baseLayer}
            layers={layers}
            activeLayers={activeLayers}
            // highlights={(formData.redLineBoundaryVisible) ?
            //     [{
            //         key: selectedHighlightInfo.layerSystemName,
            //         layerSystemName: selectedHighlightInfo.layerSystemName,
            //         features: selectedSites
            //     }, {

            //     }] : []
            // }
            drawStyles={previewStyles}
            drawnFeatures={drawnFeatures}
            // drawStyles={(formData.redLineBoundaryVisible && selectedDrawnFeatures) ? previewStyles : []}
            fitBounds={fitBounds}
            fitBoundsOptions={{
                padding: 0,
                pitch: 0,
                bearing: 0
            }}
            factoryParameters={{
                preserveDrawingBuffer: true,
                fadeDuration: 0
            }}
            onMapLoaded={onStyleLoaded}
            {...otherProps}
            // onImageReady={() => {}}
        />
    );
}

function mapPropsAreEqual (prevProps, nextProps) {
    return prevProps.baseLayer.id === nextProps.baseLayer.id &&
        _.isEqual(prevProps.activeLayers, nextProps.activeLayers) &&
        _.isEqual(prevProps.drawnFeatures, nextProps.drawnFeatures) &&
        prevProps.siteCardsEnabled === nextProps.siteCardsEnabled &&
        _.isEqual(prevProps.fitBounds, nextProps.fitBounds);
}

export const MemoizedPrintMapInner = React.memo(PrintMapInner, mapPropsAreEqual);